const enviroment = {
  apiUrl: process.env.REACT_APP_API_URL, // || window.ENV.URL_BACKEND,
  socketUrl: process.env.REACT_APP_SOCKET_URL || window.ENV.URL_REALTIME,
  faqUrl: process.env.REACT_APP_FAQ_URL || window.ENV.URL_FAQ,
  mapApiKey: 'AIzaSyC6utTCtC_j5WS93fz8xAxSweRc0J8eYT8', // process.env.REACT_APP_GOOGLE_MAP_API_KEY
  isDev: process.env.NODE_ENV === 'development',
  platform: window.location.href.includes('mubon') ? 'mubon' : 'celsia',
};

// eslint-disable-next-line import/prefer-default-export
export { enviroment };
